/** Same asset as chillnpark_admin (public/images/logo/auth-logo.svg) */
export const LOGO_SRC = "/images/logo/chillnpark-logo.svg";
